export const EarhivUiComponents = {
  ACTION_SAVE_MJESTO: 'saveAgentMjesto',
  DENY_AGENT_VERIFICATION: 'denyAgentVerification',
  DELETE_LIST_USERS_ACTION: 'deleteListUsersAction',
  ACTIVATE_DEACTIVATE_ITEMS_ACTION: 'activateDeactivateItemsAction',
  EDITABLE_ITEMLIST_INPUT: 'editableItemlistInput',
  CHOOSE_FROM_PERSON_NORMATIVE_DB_ACTION:
    'chooseFromPersonNormativeDatabaseAction',
  SAVE_CLOSE_ARHIV_POSJEDNIK_ACTION: 'saveCloseArhivPosjednikAction',
  PUBLISH_CLOSE_ARHIV_POSJEDNIK_ACTION: 'publishCloseArhivPosjednikAction',
  SAVE_CLOSE_CHILD_ITEM_ACTION: 'saveCloseChildItemAction',
  ARHIVSKA_OZNAKA_INPUT: 'arhivskaOznakaInput',
  DEFAULT_HEADING_ACTION: 'defaultHeadingAction',
  AGENT_ITEM_VIEW: 'agentItemView',
  PREDAJA_ITEM_VIEW: 'predajaItemView',
  JEDINICA_GRADIVA_ITEM_VIEW: 'jedinicaGradivaItemView',
  SPREMISTE_OBJEKTI_VIEW: 'viewSpremisteObjekt',
  SPREMISTE_PROSTORIJE_VIEW: 'viewSpremisteProstorija',
  SPREMISTE_SPREMISNA_JEDINICA_VIEW: 'viewSpremisteSpremisnaJedinica',
  SPREMISTE_LOKACIJA_VIEW: 'viewSpremisteLokacija',
  SPREMISTE_PROSTORIJE_LIST_VIEW: 'spremisteProstorijeListView',
  ARHIV_POSJEDNIK_ITEM_VIEW: 'arhivPosjednikItemView',
  POVIJEST_PROMJENA_ITEM_VIEW: 'povijestPromjenaItemView',
  NAPOMENE_IZLUCIVANJE_LIST_VIEW: 'napomeneIzlucivanjeListView',
  NAPOMENE_PREDAJA_LIST_VIEW: 'napomenePredajaListView',
  LOCK_UNLOCK_ITEMS_ACTION: 'lockUnlockItemsAction',
  POJAVNI_OBLIK_ITEM_VIEW: 'pojavniOblikItemView',
  FIZICKI_OBJEKT_ITEM_VIEW: 'fizickiObjektItemView',
  NEW_JEDINICA_GRADIVA_ACTION: 'newJedinicaGradivaAction',
  NEW_IZLUCIVANJE_ACTION: 'newIzlucivanjeAction',
  TABLE_LIST_GRID_VIEW: 'tableListGridView',
  DEDUPLICATION_AGENT_DROPDOWN: 'deduplicationAgentDropdown',
  ROK_CUVANJA_TREE_INPUT: 'rokCuvanjaTreeInput',
  COMMON_TABLE_LIST_GRID_VIEW: 'commontableListGridView',
  GEONAMES_INTEGRATION_INPUT: 'geonamesIntegrationInput',
  VIAF_INTEGRATION_INPUT: 'viafIntegrationInput',
  NEW_OBJEKTI_POJAVNOG_OBLIKA_ACTION: 'newObjektiPojavnogOblikaAction',
  NEW_CHILD_ENTITY_ACTION: 'newChildEntityAction',
  NEW_REPORT_ITEM: 'newReportItem',
  IZVJESTAJ_ITEM_VIEW: 'reportItemView',
  SAVE_CLOSE_REFRESH_ACTION: 'saveCloseRefreshAction',
  SAVE_CLOSE_KREIRANJE_FIZICKI_OBJEKTI_ACTION:
    'saveCloseKreiranjeFizickiObjektiAction',
  PUBLISH_UNPUBLISH_JEDINICE_ACTION: 'publishUnpublishJediniceAction',
  SEND_TO_VERIFICATION_ACTION: 'sendToVerificationAction',
  TASK_ITEM_VIEW: 'taskItemView',
  TREELISTVIEW: 'ntapTreeListView',
  JEDINICE_INVENTURE_ITEM_VIEW: 'jediniceInventureItemView',
  SERVER_CLOSE: 'serverCloseAction',
  SEND_FORM_DATA: 'serverSendFormDataAction',
  JEDINICA_HIERARCHY_PICKER: 'jedinicaHierarchyPicker',
  PREMJESTI_JEDINICE: 'premjestiJedinice',
  POTVRDI_PREMJESTANJE_JEDINICE: 'potvrdiPremjestanjeJedinice',
  DELETE_LIST_ITEMS_ARHIV_ITEM_ACTION: 'deleteArhivListItemsAction',
  SPREMI_IZLUCIVANJE_ACTION: 'saveCloseIzlucivanjeAction',
  NEW_PREDAJA_ACTION: 'newPredajaAction',
  DELETE_LIST_ITEMS_ACTION: 'deleteListItemsAction',
  OPEN_ITEM_VIEW_ACTION: 'openItemView',
  DOSTAVA_JEDINICA_ACTION: 'pokreniDostavuJedinicaAction',
  VRIJEME_RANGE_KOMPLEKSNI_INPUT: 'rangeKompleksniInput',
  VRIJEME_KOMPLEKSNI_INPUT: 'vrijemeKompleksniInput',
  OBJAVA_ODOBJAVA_JEDINICA_ACTION: 'publishUnpublishJedinicaAction',
  NEW_FOLDER_ACTION: 'newFolderAction',
  EDIT_JEDINICA_GRADIVA_DOKUMENTACIJA: 'EditJedinicaGradivaDokComponent',
  READ_JEDINICA_GRADIVA_DOKUMENTACIJA: 'ReadJedinicaGradivaDokComponent',
  LAZY_DROPDOWN_INPUT: 'lazyDropdownInput',
  LOCATION_FROM_STORAGE: 'locationFromStorage',
  DEDUPLICATE_LIST_ITEMS_ACTION: 'deduplicateListAgentAction',
  SAVE_CLOSE_DEDUPLICATE_AGENT_ITEMS_ACTION: 'saveCloseDeduplicatedAgent',
  ADD_POPIS_ROKOVA_CUVANJA_FOR_SPECIFIC_PARENT_ID:
    'addPopisRokovaCuvanjaForSpecificParentId',
  OPEN_NESTED_VIEW_ACTION: 'openNestedViewAction',
  MJESTO_ITEM_VIEW: 'mjestoItemView',
  EXPORT_AGENT_DATA_ACTION: 'exportAgentDataAction',
  EXPORT_AGENT_DRUGI_ZAPISI_ACTION: 'exportAgentDrugiZapisiAction',
  EDIT_ACTIONBAR: 'editActionbar',
  EXPORT_JEDINICE_GRADIVA_XLSX_ACTION: 'exportJediniceGradivaXlsxAction',
  POJAVNI_OBLIK_NAZIV_INPUT: 'pojavniOblikNazivInput',
  OPEN_ARHIV_POSJEDNIK_FROM_JEDINICA_GRADIVA_ACTION:
    'openArhivPosjednikIzJediniceGradiva',
  ODABIR_POVEZANE_JEDINICE_GRADIVA_IZ_POSTOJECIH:
    'odabirPovezaneJediniceGradivaIzPostojecih',
  PRINT_LABEL_PDF_ACTION: 'printLabelPdfAction',
  PRINT_LABEL_SPREMSITE_PDF_ACTION: 'printLabelSpremistePdfAction',
  PRINT_LABEL_DOSTAVA_PDF_ACTION: 'printLabelDostavaPdfAction',
  PRINT_POTVRDA_PRIMITKA_ACTION: 'printPotvrdaPrimitkaAction',
  PRINT_OMOTA_SPISA_ACTION: 'printOmotaSpisaAction',
  LIST_AND_DIALOG_ACTION: 'listAndDialogAction',
  EDIT_JEDINICA_ITEM: 'editJedinicaItem',
  EDIT_INVENTURA_ITEM: 'editInventuraItem',
  SPREMISTE_2D_PREGLED_ACTION: 'spremisteGrafikaAction',
  ODABIR_JEDINICE_GRADIVA_ZA_ISTAKNUTI_SADRZAJ:
    'odabirJediniceZaIstaknutiSadrzaj',
  MICANJE_JEDINICE_IZ_ISTAKNUTOG_SADRZAJA: 'micanjeJediniceIstaknutiSadrzaj',
  SAVE_STATUS_OTPREME_FOR_MORE_OTPREMAS: 'saveStatusOtpremeForMoreOtpremas',
  RESTAURACIJA_ITEM_VIEW: 'restauracijaItemView',
  PREDMET_RESTAURACIJE_VIEW: 'predmetRestauracijeItemView',
  ODABIR_POJAVOG_OBLIKA_ZA_RESTAURACIJU: 'odabirPojavnogZaRestauraciju',
  ODABIR_FIZICKOG_OBJEKTA_ZA_RESTAURACIJU: 'odabirFizickogZaRestauraciju',
  RAZMJESTI_NIZE_LIST: 'razmjestiNizeList',
  RAZMJESTI_NIZE_LIST_ITEMS_ACTION: 'razmjestiNizeListItemsAction',
  CONFIRM_DOSTAVU_FIZICKIH_OBJEKATA: 'confirmDostavuFizickiObjektUI',
  RETURN_FIZICKI_OBJEKT_TO_SPREMISTE: 'returnFizickiObjektToSpremisteUI',
  POTVRDI_POVRAT_FIZICKOG_OBJEKTA_ACTION: 'confirmFizickiObjektPovratUI',
  POTVRDI_IZDAVANJE_FIZICKOG_OBJEKTA_ACTION: 'confirmFizickiObjektIzdavanjeUI',
  GENERIRAJ_JEDINICA_GRADIVA_IZLUCIVANJE_REL_ACTION:
    'generirajIzlucivanjeJedinicaGradivaRelAction',
  DODAJ_JEDINICE_GRADIVA_U_ZAHTJEV: 'dodajJediniceGradivaUZahtjev',
  PREMJESTI_DOK_JEDINICU_ACTION: 'premjestiDokJedinicu',
  PREMJESTI_DOKUMENT_ACTION: 'premjestiDokumentAction',
  KOPIRAJ_DOKUMENT_ACTION: 'kopirajDokumentAction',
  OBUSTAVI_ROK_CUVANJA: 'obustaviRokCuvanjaAction',
  NIJE_INVENTURA: 'nijeInventuraAction',
  IZRADI_KLASIFIKACIJSKU_OZNAKU: 'izradiKlasifikacijskuOznakuAction',
  ODABIR_FIZICKOG_OBJEKTA_U_SPREMISTE: 'odabirFizickogUSpremiste',
  DATOTEKA_ITEM_VIEW: 'datotekaItemView',
  ARHIVSKA_KLASIFIKACIJA: 'arhivskaKlasifikacija',
  ODABIR_KORISNIKA_CITAONICE: 'odabirKorisnikaCitaonice',
  SAVE_CLOSE_KORISNIK_CITAONICE: 'saveCloseKorisnikaCitaonice',
  ODABIR_JEDINICE_PREDAJA: 'odabirJediniceZaPredaju',
  ODABIR_POJAVOG_OBLIKA_ZA_PREDAJU: 'odabirPojavnogZaPredaju',
  ODABIR_FIZICKOG_OBJEKTA_ZA_PREDAJU: 'OdabirFizickogZaPredajuComponent',
  POSALJI_U_EKULTURU_ACTION: 'posaljiUEKulturuAction',
  DELETE_OBRAZAC_UPISA_ACTION: 'deleteObrazacUnosaAction',
  SPREMI_DATOTEKE_ACTION: 'spremiDatotekeAction',
  VERIFICIRAJ_ACTION: 'verifyItemsAction',
  PROMJENA_PORETKA_ACTION: 'promjenaPoretkaAction',
  UKLONI_FIZICKI: 'ukloniFizickiAction',
  BASIC_ITEMS_LIST_ACTION: 'BasicItemsListAction',
  ZAKLJUCENJE_PREDMETA_ACTION: 'zakljuciPredmetAction',
  VRACANJE_PREDMETA_U_OBRADU_ACTION: 'vratiPredmetUObradu',
  OBRISI_DOKUMENTACIJA_JEDINICA_LIST_ITEM:
    'deleteDokumentacijaJedinicaListItem',
  PREUZMI_DOK_FOLDER: 'downloadFileOrFolderAction',
  OTVORI_DOK_U_TABU: 'openFileInNewTabAction',
  PREUZMI_DOK_MULTIPLE_FILES: 'downloadFilesOrFoldersAction',
  FIZICKI_OBJEKTI_VISIH_RAZINA_LIST_VIEW: 'fizickiObjektiVisihRazinaList',
  DATOTEKE_VISIH_RAZINA_LIST_VIEW: 'datotekeVisihRazinaList',
  CONFIRMATION_JEDINICE_GRADIVA: 'confirmationJediniceGradiva',
  SAVE_OPEN_NEW_PODRAZINA: 'saveOpenNewPodrazina',
  OPEN_POVEZANA_JEDINICA_GRADIVA_ACTION: 'openPovezanaJedinicaGradivaAction',
  VERIFY_AGENTS_ACTION: 'verifyAgentsAction',
  PUBLISH_UNPUBLISH_AGENTS: 'publishUnpublishAgents',
  ODABIR_POVEZANOG_AGENTA: 'odabirPovezanogAgenta',
  ODABIR_POVEZANE_OSOBE: 'odabirPovezaneOsobe',
  ODABIR_POVEZANOG_PRIMATELJA: 'odabirPovezanogPrimatelja',
  ODABIR_POVEZANOG_POSILJATELJA: 'odabirPovezanogPosiljatelja',
  ODABIR_STRANKE: 'odabirStranke',
  OPEN_POVEZANI_AGENT_ACTION: 'openPovezaniAgentAction',
  LOCATE_IN_DOKUMENTACIJA_TREE: 'locateInDokumentacijaTree',
  ODABIR_JEDINICE_DOSTAVA: 'odabirJediniceZaDostavu',
  ODABIR_POJAVOG_OBLIKA_ZA_DOSTAVU: 'odabirPojavnogZaDostavu',
  ODABIR_FIZICKOG_OBJEKTA_ZA_DOSTAVU: 'OdabirFizickogZaDostavuComponent',
  ODABIR_POVEZANOG_MJESTA: 'odabirPovezanogMjesta',
  OPEN_POVEZANO_MJESTO_ACTION: 'openPovezanoMjestoAction',
  ZAPRIMANJE_POSILJKI: 'zaprimanjePosiljkiAction',
  OPEN_EDIT_AGENT_ACTION: 'agentOpenItemViewAction',
  EXPORT_JEDINICE_GRADIVA_ACTION: 'exportJediniceGradivaAction',
  POVEZI_DOKUMENTACIJA_PREDMET: 'poveziDokumentacijaPredmet',
  RAZDVOJI_DOKUMENTACIJA_PREDMET: 'razdvojiDokumentacijaPredmet',
  JEDINICA_GRADIVA_TABLE_LIST_GRID_VIEW: 'jedinicaGradivaGridListView',
  PROMIJENI_LOKACIJU_FIZICKI_OBJEKTI_ACTION:
    'promijeniLokacijuFizickiObjektiAction',
  BASIC_FILE_INPUT: 'basicFileInput',
  KLASIFIKACIJSKI_SIFRARNIK_INPUT: 'klasSifrarnikInput',
  ROK_CUVANJA_HIERARCHY_DROPDOWN: 'hierarchyDropdown',
  DELETE_MULTIPLE_DOCUMENTS_ACTION: 'deleteMultipleDocumentsAction',
  ADD_PARENT_TO_KLASA: 'addParentToKlasa',
  SAVE_CLOSE_REFRESH_DOKUMENTACIJA_ACTION:
    'saveCloseRefreshDokumentacijaAction',
  SAVE_REFRESH_DOKUMENTACIJA_ACTION: 'saveRefreshDokumentacijaAction',
  UPRAVNA_STVAR_INPUT: 'upravnaStvarInput',
  OPEN_VEZANO_GRADIVO_OSOBA_ACTION: 'openVezanoGradivoOsobaAction',
  UKLONI_ROK_CUVANJA_ACTION: 'ukloniRokCuvanjaAction',
  JEDINICA_GRADIVA_INHERITABLE_ATTRIBUTE_INPUT:
    'jedinicaGradivaInheritableAttrInput',
  NEW_DIREKTORIJ_POJAVNOG: 'newDirektorij',
  PREDAJA_DELETE_ACTION: 'predajaDeleteAction',
  EDIT_ARHIV_POSJEDNIK_ACTION: 'editArhivPosjednikAction',
  EDIT_POJAVNI_OBLIK_ACTION: 'editPojavniOblikAction',
  POSTAVI_STATUS_OTPREME_ACTION: 'postaviStatusOtpremeAction',
  NEW_ZAHTJEV_ACTION: 'newZahtjevAction',
  DISABLE_FOR_UNSELECTED: 'disableForUnselectedAction',
  ODABIR_POJAVOG_OBLIKA_ZA_IZLUCIVANJE: 'odabirPojavnogZaIzlucivanje',
  OPEN_KORISNIK_CITAONICE: 'openKorisnikCitaoniceAction',
  ODABIR_JEDINICE_RAZMJESTENO_U: 'odabirJediniceRazmjestenoU',
  DEDUPLICATE_MJESTO_LIST_ITEMS_ACTION: 'deduplicateMjestoListAction',
  DEDUPLICATION_MJESTO_DROPDOWN: 'deduplicationMjestoDropdown',
  SAVE_CLOSE_DEDUPLICATED_MJESTO_ITEMS_ACTION:
    'saveCloseDeduplicatedMjestoAction',
  MJESTO_PRIKAZ_COMPONENT: 'mjestoPrikazComponent',
  DENY_MJESTO_DEDUPLICATION_COMPONENT: 'denyMjestoDeduplication',
  CHANGE_AGENT_ASSIGNED_USER: 'changeAgentsAssignedUser',
  EDIT_DOKUMENTACIJA_DATOTEKA_ACTION: 'editDokumentacijaDatotekaAction',
  POJAVNI_OBLIK_INHERITABLE_ATTRIBUTE_INPUT: 'PojavniOblikInheritableAttrInput',
  ACTIVATE_DEACTIVATE_KLASA_ITEMS_ACTION: 'activateDeactivateKlasaItemsAction',
  OBRISI_KLASA_LIST_ITEM_ACTION: 'deleteKlasaListItemAction',
  NEW_PREDMET_ACTION: 'newPredmetAction',
  NEW_DOKUMENT_ACTION: 'newDokumentAction',
  LOCK_UNLOCK_DOKUMENTACIJA_ITEMS_ACTION: 'lockUnlockDokItemsAction',
  NEW_KLASA_ACTION: 'newKlasaAction',
  SEUP_SUBJEKT_ITEM_VIEW: 'seupSubjektItemView',
  OPEN_KONVERZIJA_POJAVNI_OBLIK_ACTION: 'openKonverzijaPojavniOblikItemView',
  KONVERTIRAJ_POJAVNI_OBLIK_ACTION: 'konvertirajPojavniOblikAction',
  OPEN_GENERATOR_URBROJ_ACTION: 'openGeneratorUrbrojAction'
};
